import { MAIN_ENDPOINT } from "../../../config/api-client";

export const QUERY_KEY = "work-sites";
export const ENDPOINT = MAIN_ENDPOINT;
